import { Card } from '@wundo/ui';

/**
 * What actually happens after Plan Broadcast is pressed.
 *
 * It is on the form rather than in a doc because every one of these rules moves
 * the send time away from what was just typed, and finding that out afterwards
 * is how a broadcast lands on a Saturday nobody meant.
 */
export function DeliveryRules({ hasSendTime }: { hasSendTime: boolean }) {
  return (
    <Card tone='quiet' as='section' aria-label="How it's delivered">
      <h3 className='text-sm font-bold text-ink'>How it&apos;s delivered</h3>
      <ul className='mt-2 flex list-inside list-disc flex-col gap-1 text-sm text-ink-secondary'>
        <li>
          Goes to every <strong className='font-bold'>active</strong> user in the chosen
          cohorts.
        </li>
        <li>
          <strong className='font-bold'>Weekdays only.</strong> A weekend date is
          delivered early the next weekday, not at the chosen time.
        </li>
        {hasSendTime && (
          <li>
            <strong className='font-bold'>
              Very early times wait for the morning prep.
            </strong>{' '}
            A broadcast for a future day is prepared by a job that runs about 02:00 UTC
            each weekday, so a send time earlier than that goes out then. A broadcast for
            today is prepared right away.
          </li>
        )}
        <li>
          <strong className='font-bold'>Never mid-conversation.</strong> If the user is
          chatting at the send time, it waits until they&apos;ve paused (5 min, or 1 hour
          if the agent is awaiting a reply).
        </li>
        <li>
          Skipped for users who already have a recommendation queued, or a reminder or
          check-in landing that day — those take priority.
        </li>
      </ul>
    </Card>
  );
}
